import { Repository } from './PassChange_Repository';
var repo = new Repository();


export default {
  exampleAction(context, { data }) {

   
  }
  
}



// WEBPACK FOOTER //
// ./VueSrc/Common/Store/Security/PassChange_actions.js